import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const IntegrationsJumbotron = () => (
  <LandingPageJumbotron
    contentWidth="tight"
    description="integrations_privacy_section_copy"
    title="integrations_privacy_section_title"
  />
);

export default IntegrationsJumbotron;
